import { useState, useEffect } from "react";
import { saveDepartmentDetails, getOfficeData } from "../Api/DepartmentMaster";
import {
  Accordion,
  AccordionItem,
  AccordionBody,
  Form,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const DepartmentMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [isFetchingOffices, setIsFetchingOffices] = useState(false);

  const [departmentData, setDepartmentData] = useState({
    code: "",
    description: "",
    officeCode: "",
  });

  useEffect(() => {
    const fetchOfficeData = async () => {
      setIsFetchingOffices(true);
      try {
        const data = await getOfficeData();
        // Assuming the API returns an array of objects with officeCode and officeName properties
        setOfficeOptions(
          data.map((office) => ({
            code: office.officeCode,
            name: `${office.officeCode} - ${office.officeName}`,
          }))
        );
      } catch (error) {
        toast.error("Failed to load office data");
        console.error("Error fetching office data:", error);
      } finally {
        setIsFetchingOffices(false);
      }
    };

    fetchOfficeData();
  }, []);

  const handleChange = (e) => {
    setDepartmentData({ ...departmentData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveDepartmentDetails(departmentData);
      toast.success("Department Added Successfully");
      setDepartmentData({ code: "", description: "", officeCode: "" });
      navigate("/viewDepartmentMaster");
    } catch (error) {
      toast.error("Error occurred while adding department");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container department-fields">
        <h2 className="fields-title">Department Master</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion
            defaultActiveKey="0"
            className="department-master-accordion"
          >
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="code"
                        value={departmentData.code}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Description <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={departmentData.description}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Office Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="officeCode"
                        value={departmentData.officeCode}
                        onChange={handleChange}
                        required
                        disabled={isFetchingOffices}
                      >
                        <option value="">Select Office</option>
                        {officeOptions.map((office) => (
                          <option key={office.code} value={office.code}>
                            {office.name}
                          </option>
                        ))}
                      </Form.Select>
                      {isFetchingOffices && (
                        <small className="text-muted">Loading offices...</small>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button
              variant="primary"
              type="submit"
              className="fields-submit"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Department"}
            </Button>
          </div>
        </Form>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default DepartmentMaster;
